module.exports = __webpack_public_path__ + "img/cashFlow-sm.fb0a112a.svg";